import React from "react";
import {HeaderThElement} from "@progress/kendo-react-data-tools";

export const CenteredHeaderCell = ({ children, thProps}) => {

    return (
        <HeaderThElement {...thProps} style={{justifyContent: "center", ...thProps.style}}>
            {children}
        </HeaderThElement>
    );
};